var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorageLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 10V11.3333M3.99935 14H11.9993C12.7357 14 13.3327 13.403 13.3327 12.6667V8.66667C13.3327 7.93029 12.7357 7.33333 11.9993 7.33333H3.99935C3.26297 7.33333 2.66602 7.93029 2.66602 8.66667V12.6667C2.66602 13.403 3.26297 14 3.99935 14ZM10.666 7.33333V4.66667C10.666 3.19391 9.47211 2 7.99935 2C6.52659 2 5.33268 3.19391 5.33268 4.66667V7.33333H10.666Z",
    stroke: "#641616",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageLocked);
export default __webpack_public_path__ + "static/media/storage-locked.41bdefedf3f18453c8dcf3a28a036b4a.svg";
export { ForwardRef as ReactComponent };